import { MenuOptions } from '../types/Menu';

export const APP_NAME = 'AI Cocina Virtual';
export const APP_VERSION = '1.0.0';

export const DEFAULT_MENU_OPTIONS: MenuOptions = {
  showPreparation: true,
  showNutritionalInfo: false,
  showAlternatives: false,
  useThermomix: false,
  difficulty: 'medium',
  cookingTime: 'medium',
  courseCount: 1,
  maxPricePerDish: 10
} as const;

export const MENU_TYPES = {
  BASIC: 'basic',
  AI: 'ai'
} as const;